<template>
  <yandex-map
      :coords="$props.coordinates"
      :zoom="$props.zoom"
      :controls="setControls"
      :options="{ suppressMapOpenBlock: true }"
  >
    <ymap-marker
        :coords="$props.coordinates"
        :marker-id="0"
    />
  </yandex-map>
</template>

<script>
import { yandexMap, ymapMarker } from 'vue-yandex-maps'

export default {
  name: 'YandexMaps',

  components: { yandexMap, ymapMarker },

  data() {
      return {
        setControls: ["zoomControl", ],
    }
  },

  props: {
    coordinates: {
      type: Array,
      required: true,
    },
    zoom: {
      type: Number,
      required: true,
    }
  },

  methods: {
  },
}
</script>

<style lang="scss">
.ymap-container {
  margin: 10px 0 0 10px;
  height: 100%;
  width: 100%;
}
</style>